/* ==========================================================================
   ajaxify.js (optimised for MODAL + DRAWER on collections)
   - Instant open with wireframe shimmer (before network)
   - Fast-path add (id+quantity) when safe
   - Cached Handlebars templates (no recompile on every open)
   - Image decode hints; no ghost reopen after closing
   - **Deduped modal open (no double-open)**
   ========================================================================== */

if (typeof Shopify === 'undefined') { window.Shopify = {}; }

/* ---------- Inline shimmer + perf styles (wireframe) ---------- */
(function(){
  var css = `
    @keyframes ajaxifyShimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
    .ajaxifySkel {
      background-color: #f6f7f8;
      background-image: linear-gradient(90deg, #f6f7f8, #edeef1, #f6f7f8);
      background-size: 200% 100%;
      animation: ajaxifyShimmer 1.2s infinite linear;
    }
    .ajaxifyCart--skeleton { padding: 16px; }
    .ajaxifyCart--skeleton .skel-row {
      display: grid; grid-template-columns: 64px 1fr auto; grid-gap: 12px;
      align-items: center; margin-bottom: 14px;
    }
    .ajaxifyCart--skeleton .skel-img { width: 64px; height: 64px; border-radius: 6px; }
    .ajaxifyCart--skeleton .skel-lines { display: grid; grid-gap: 6px; }
    .ajaxifyCart--skeleton .skel-line { height: 10px; border-radius: 5px; }
    .ajaxifyCart--skeleton .skel-line.w60 { width: 60%; }
    .ajaxifyCart--skeleton .skel-line.w40 { width: 40%; }
    .ajaxifyCart--skeleton .skel-line.w30 { width: 30%; }
    .ajaxifyCart--skeleton .skel-qtyprice { display:flex; flex-direction: column; align-items:flex-end; gap:6px; min-width: 68px; }
    .ajaxifyCart--skeleton .skel-pill { height: 18px; width: 56px; border-radius: 999px; }
    .ajaxifyCart--skeleton .skel-price { height: 12px; width: 48px; border-radius: 6px; }
    .ajaxifyCart--skeleton .skel-footer {
      border-top: 1px solid #eceff1; margin-top: 12px; padding-top: 12px;
      display: grid; grid-template-columns: 1fr auto; align-items: center; grid-gap: 12px;
    }
    .ajaxifyCart--skeleton .skel-subtotal { height: 14px; width: 120px; border-radius: 6px; }
    .ajaxifyCart--skeleton .skel-cta { height: 40px; width: 150px; border-radius: 8px; }
    .ajaxifyDrawer { will-change: height, transform; }
    .ajaxifyDrawer.is-opening { transition: none !important; }
    #ajaxifyModal { will-change: transform, opacity; transform: translateZ(0); }
    #ajaxifyModal.is-opening { transition: none !important; }
  `;
  var style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();

/* ---------- Utils ---------- */
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute = (attribute + '');
    if (attribute === 'undefined') attribute = '';
  }
  return jQuery.trim(attribute);
}

if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);
    if (typeof cents === 'string') cents = cents.replace('.', '');
    function def(opt, d) { return (typeof opt === 'undefined' ? d : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = def(precision, 2);
      thousands = def(thousands, ',');
      decimal   = def(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number/100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch((formatString.match(placeholderRegex)||[])[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onProduct = function(product){};
Shopify.onCartUpdate = function(cart){};

Shopify.onError = function (XMLHttpRequest) {
  var raw = XMLHttpRequest && XMLHttpRequest.responseText;
  var data;
  try { data = raw ? JSON.parse(raw) : {}; } catch(e){ data = {}; }
  if (data && (data.message || data.description)) {
    alert((data.message || 'Error') + (data.status ? ' ('+data.status+')' : '') + ': ' + (data.description || ''));
  } else {
    alert('An unexpected error occurred. Please try again.');
  }
};

Shopify.updateCartNote = function (note, callback) {
  jQuery.ajax({
    type: 'POST', url: '/cart/update.js',
    data: 'note=' + attributeToString(note), dataType: 'json',
    success: function (cart) { if (typeof callback==='function') callback(cart); else Shopify.onCartUpdate(cart); },
    error: Shopify.onError
  });
};

Shopify.addItem = function (variant_id, quantity, callback) {
  quantity = quantity || 1;
  jQuery.ajax({
    type: 'POST', url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id, dataType: 'json',
    success: function (line_item) { if (typeof callback==='function') callback(line_item); else Shopify.onItemAdded && Shopify.onItemAdded(line_item); },
    error: Shopify.onError
  });
};

Shopify.addItemFromForm = function (form, callback, errorCallback) {
  jQuery.ajax({
    type: 'POST', url: '/cart/add.js',
    data: jQuery(form).serialize(), dataType: 'json',
    success: function (line_item) { if (typeof callback==='function') callback(line_item, form); else Shopify.onItemAdded && Shopify.onItemAdded(line_item, form); },
    error: function (XMLHttpRequest, textStatus) { if (typeof errorCallback==='function') errorCallback(XMLHttpRequest, textStatus); else Shopify.onError(XMLHttpRequest, textStatus); }
  });
};

Shopify.getCart = function (callback) {
  jQuery.getJSON('/cart.js', function (cart) { if (typeof callback==='function') callback(cart); else Shopify.onCartUpdate(cart); });
};

Shopify.getProduct = function (handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product) { if (typeof callback==='function') callback(product); else Shopify.onProduct(product); });
};

Shopify.changeItem = function (line, quantity, callback) {
  jQuery.ajax({
    type: 'POST', url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line, dataType: 'json',
    success: function (cart) { if (typeof callback==='function') callback(cart); else Shopify.onCartUpdate(cart); },
    error: Shopify.onError
  });
};

/* ---------- Wireframe skeleton builder ---------- */
function buildCartSkeleton(rows) {
  rows = Math.max(1, parseInt(rows || 3, 10));
  var rowsHtml = '';
  for (var i = 0; i < rows; i++) {
    rowsHtml += `
      <div class="skel-row">
        <div class="ajaxifySkel skel-img"></div>
        <div class="skel-lines">
          <div class="ajaxifySkel skel-line w60"></div>
          <div class="ajaxifySkel skel-line w40"></div>
        </div>
        <div class="skel-qtyprice">
          <div class="ajaxifySkel skel-pill"></div>
          <div class="ajaxifySkel skel-price"></div>
        </div>
      </div>
    `;
  }
  return `
    <div class="ajaxifyCart--skeleton">
      ${rowsHtml}
      <div class="skel-footer">
        <div class="ajaxifySkel skel-subtotal"></div>
        <div class="ajaxifySkel skel-cta"></div>
      </div>
    </div>
  `;
}

/* ---------- Ajaxify module ---------- */
var ajaxifyShopify = (function (module, $) {
  'use strict';

  var init;

  var settings, isUpdating, cartInit, $drawerHeight, $cssTransforms, $cssTransforms3d, $nojQueryLoad, $w, $body, $html;

  var $formContainer, $btnClass, $wrapperClass, $addToCart, $flipClose, $flipCart, $flipContainer, $cartCountSelector, $cartCostSelector, $toggleCartButton, $modal, $cartContainer, $drawerCaret, $modalContainer, $modalOverlay, $closeCart, $drawerContainer, $prependDrawerTo;

  var updateCountPrice, flipSetup, revertFlipButton, modalSetup, showModal, sizeModal, hideModal, drawerSetup, showDrawer, hideDrawer, sizeDrawer, loadCartImages, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, setToggleButtons, flipCartUpdateCallback, buildCart, cartTemplate, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, scrollTop, toggleCallback, validateQty;

  // perf helpers & template cache
  var openDrawerSkeletonImmediate, openModalSkeletonImmediate, fastAddFromForm;
  var TPL = { cart: null, modal: null, drawer: null };

  // prevent unwanted reopen
  var intendedModalOpen = false;
  var intendedDrawerOpen = false;

  // simple re-entrancy locks to block double-open bursts
  var openLocks = { modal: false, drawer: false };
  function withOpenLock(which, fn){
    if (openLocks[which]) return;
    openLocks[which] = true;
    try { fn(); } finally {
      setTimeout(function(){ openLocks[which] = false; }, 300);
    }
  }

  // NEW: suppression window to ignore open attempts just after a close
  var SUPPRESS_MS = 700;
  var modalSuppressUntil = 0;

  // raf throttle
  var rafThrottle = (function(){
    var queued = false;
    return function(fn){
      if (queued) return;
      queued = true;
      requestAnimationFrame(function(){ queued = false; fn(); });
    };
  }());

  init = function (options) {
    settings = {
      method: 'drawer', // 'drawer' | 'modal' | 'flip'
      formSelector: 'form[action^="/cart/add"]',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      toggleCartButton: null,
      btnClass: null,
      wrapperClass: null,
      useCartTemplate: false,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true,
      prependDrawerTo: 'body',
      onToggleCallback: null
    };

    $.extend(settings, options);
    settings.method = (settings.method || '').toLowerCase();

    if ($('body').hasClass('template-product')) { settings.method = 'modal'; }

    // Cache DOM
    $formContainer     = $(settings.formSelector);
    $btnClass          = settings.btnClass;
    $wrapperClass      = settings.wrapperClass;
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $flipContainer     = null;
    $flipClose         = null;
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $toggleCartButton  = $(settings.toggleCartButton);
    $modal             = null;
    $prependDrawerTo   = $(settings.prependDrawerTo);

    $cssTransforms   = (window.Modernizr && Modernizr.csstransforms) || false;
    $cssTransforms3d = (window.Modernizr && Modernizr.csstransforms3d) || false;

    $w    = $(window);
    $body = $('body');
    $html = $('html');

    isUpdating = false;
    $nojQueryLoad = $html.hasClass('lt-ie9');
    if ($nojQueryLoad) settings.useCartTemplate = false;

    if (settings.enableQtySelectors) qtySelectors();

    if (!settings.disableAjaxCart) {
      switch (settings.method) {
        case 'flip':  flipSetup();  break;
        case 'modal': modalSetup(); break;
        case 'drawer': default: drawerSetup(); break;
      }

      $(document).off('keyup.ajaxify').on('keyup.ajaxify', function(evt){
        if (evt.keyCode === 27) {
          if (settings.method === 'modal') hideModal();
          else hideDrawer();
        }
      });

      if ($addToCart.length) formOverride();
    }

    adjustCart();
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector && $cartCountSelector.length) {
      $cartCountSelector.text(cart.item_count).removeClass('hidden-count');
      if (cart.item_count === 0) $cartCountSelector.addClass('hidden-count');
    }
    if ($cartCostSelector && $cartCostSelector.length) {
      var discountText = $('.discountTotal').first().text();
      if (discountText) { $('#cart-price').text(discountText); }
      else { $('#cart-price').text(Shopify.formatMoney(cart.total_price, settings.moneyFormat)); }
    }
  };

  /* ---------- Flip ---------- */
  flipSetup = function () {
    drawerSetup();
    if (!$addToCart.length) return;

    $addToCart.addClass('flip-front').wrap('<div class="flip"></div>');
    var checkoutBtn = $('<a href="/cart" class="flip-back" id="flip-checkout" style="background-color:#C00;color:#fff;">' + "Checkout" + '</a>').addClass($btnClass),
        flipLoader  = $('<span class="ajaxifyCart-loader"></span>'),
        flipExtra   = $('<div class="flip-extra">' + "or" + ' <a href="#" class="flip-cart">' + "View Basket" + ' (<span></span>)</a></div>');
    checkoutBtn.insertAfter($addToCart);
    flipLoader.insertAfter(checkoutBtn);

    $flipContainer = $('.flip');
    if (!$cssTransforms3d) $flipContainer.addClass('no-transforms');

    flipExtra.insertAfter($flipContainer);
    $flipCart = $('.flip-cart');

    $flipCart.off('click').on('click', function(e){
      e.preventDefault();
      intendedDrawerOpen = true;
      showDrawer(true);
    });

    $('input[type="checkbox"], input[type="radio"], select', $formContainer)
      .off('click.flip').on('click.flip', revertFlipButton);
  };

  revertFlipButton = function () { if ($flipContainer) $flipContainer.removeClass('is-flipped'); };

  /* ---------- Modal ---------- */
  modalSetup = function () {
    if (!window.Handlebars) { console && console.warn && console.warn('Handlebars not found; modal cannot render.'); }

    // If modal already exists (e.g., init ran twice), just wire references and bail
    if (document.getElementById('ajaxifyModal')) {
      $modalContainer = $('#ajaxifyModal');
      $modalOverlay   = $('#ajaxifyCart-overlay');
      $cartContainer  = $('#ajaxifyCart');
      setToggleButtons();
      return;
    }

    // Compile modal/drawer templates once
    var modalSource  = $("#modalTemplate").html() || '';
    var drawerSource = $("#drawerTemplate").html() || '';
    if (window.Handlebars) {
      if (modalSource && !TPL.modal)  TPL.modal  = Handlebars.compile(modalSource);
      if (drawerSource && !TPL.drawer) TPL.drawer = Handlebars.compile(drawerSource);
    }

    // Render modal shell (or fallback)
    if (TPL.modal) { $body.append(TPL.modal()); }
    else { $body.append('<div id="ajaxifyModal"><div id="ajaxifyCart"></div></div>'); }

    // Overlay (singleton guard)
    if (!document.getElementById('ajaxifyCart-overlay')) {
      $body.append('<div id="ajaxifyCart-overlay"></div>');
    }

    $modalContainer = $('#ajaxifyModal');
    $modalOverlay   = $('#ajaxifyCart-overlay');
    $cartContainer  = $('#ajaxifyCart');

    // Close by overlay — start suppression & stop propagation
    $modalOverlay.off('click').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      modalSuppressUntil = Date.now() + SUPPRESS_MS;
      intendedModalOpen = false;
      hideModal();
    });

    if (!$modalContainer.find('.ajaxifyCart--close').length) {
      $modalContainer.prepend('<button class="ajaxifyCart--close" title="' + "Close Basket" + '">' + "Close Basket" + '</button>');
    }
    $closeCart = $('.ajaxifyCart--close');
    // Close by (X) — start suppression & stop propagation
    $closeCart.off('click').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      modalSuppressUntil = Date.now() + SUPPRESS_MS;
      hideModal();
    });

    if (!$cssTransforms) $modalContainer.addClass('no-transforms');

    $w.off('resize.ajaxify orientationchange.ajaxify')
      .on('resize.ajaxify orientationchange.ajaxify', function(){
        if ($modalContainer.hasClass('is-visible')) rafThrottle(function(){ sizeModal('resize'); });
      });

    setToggleButtons();

    // Pre-compile cart template once
    var cartSource = $("#cartTemplate").html() || '';
    if (window.Handlebars && cartSource && !TPL.cart) {
      TPL.cart = Handlebars.compile(cartSource);
    }

    // MutationObserver: cancel any forced re-open during suppression
    if (window.MutationObserver && $modalContainer && $modalContainer.length) {
      var observer = new MutationObserver(function(){
        if (Date.now() < modalSuppressUntil && $modalContainer.hasClass('is-visible')) {
          intendedModalOpen = false;
          $body.removeClass('ajaxify-modal--visible ajaxify-lock');
          $modalContainer.removeClass('is-visible is-opening');
        }
      });
      observer.observe($modalContainer[0], { attributes: true, attributeFilter: ['class'] });
    }
  };

  /* helper: open modal instantly with wireframe skeleton */
  openModalSkeletonImmediate = function() {
    if (Date.now() < modalSuppressUntil) return; // suppression guard
    withOpenLock('modal', function(){
      intendedModalOpen = true;

      // If already visible, don't "re-open"
      if ($modalContainer && $modalContainer.hasClass('is-visible')) return;

      $body.addClass('ajaxify-modal--visible');
      $modalContainer.addClass('is-visible is-opening');
      if ($cartContainer) $cartContainer.html(buildCartSkeleton(3));
      requestAnimationFrame(function(){ $modalContainer.removeClass('is-opening'); });
    });
  };

  showModal = function (toggle) {
    if (Date.now() < modalSuppressUntil) return; // suppression guard
    withOpenLock('modal', function(){
      intendedModalOpen = true;

      // If already visible, just refresh data if requested and return
      if ($modalContainer && $modalContainer.hasClass('is-visible')) {
        if (toggle) Shopify.getCart(cartUpdateCallback);
        return;
      }

      $body.addClass('ajaxify-modal--visible');
      $modalContainer.addClass('is-visible is-opening');

      if (cartInit) {
        if (toggle) Shopify.getCart(cartUpdateCallback);
        requestAnimationFrame(function(){ $modalContainer.removeClass('is-opening'); });
        return;
      }

      $cartContainer.html(buildCartSkeleton(3));
      requestAnimationFrame(function(){ $modalContainer.removeClass('is-opening'); });
      Shopify.getCart(cartUpdateCallback);
    });
  };

  sizeModal = function (isResizing) {
    if (!intendedModalOpen) return;
    if (!isResizing) $modalContainer.css('opacity', 0);
    var w = $modalContainer.outerWidth();
    $modalContainer.css({ 'margin-left': -(w / 2), 'opacity': 1 }).addClass('is-visible');
    toggleCallback({ is_visible: true });
  };

  hideModal = function (e) {
    if (e) e.preventDefault();
    intendedModalOpen = false;
    $body.removeClass('ajaxify-modal--visible ajaxify-lock');
    if ($modalContainer) $modalContainer.removeClass('is-visible');
    toggleCallback({ is_visible: false });
  };

  /* ---------- Drawer ---------- */
  drawerSetup = function () {
    if (!window.Handlebars) { console && console.warn && console.warn('Handlebars not found; drawer cannot render.'); }

    // If drawer already exists, don't append a second one
    if (document.querySelector('.ajaxifyDrawer')) {
      $drawerContainer = $('.ajaxifyDrawer');
      $cartContainer   = $('.ajaxifyCart');
      $drawerCaret     = $('.ajaxifyDrawer-caret > span');
      setToggleButtons();
      return;
    }

    var source = $("#drawerTemplate").html() || '';
    if (window.Handlebars && source && !TPL.drawer) TPL.drawer = Handlebars.compile(source);
    var markup = TPL.drawer ? TPL.drawer({ wrapperClass: $wrapperClass }) : '<div class="ajaxifyDrawer"><div class="ajaxifyCart"></div></div>';
    $prependDrawerTo.prepend(markup);

    $drawerContainer = $('.ajaxifyDrawer');
    $cartContainer   = $('.ajaxifyCart');
    $drawerCaret     = $('.ajaxifyDrawer-caret > span');

    setToggleButtons();

    var resizeTimer;
    $w.off('resize.drawer').on('resize.drawer', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        if ($drawerContainer.hasClass('is-visible')) {
          positionCaret();
          sizeDrawer();
        }
      }, 120);
    });

    positionCaret();

    function positionCaret() {
      if ($toggleCartButton && $toggleCartButton.offset && $toggleCartButton.offset()) {
        var togglePos = $toggleCartButton.offset(),
            toggleWidth = $toggleCartButton.outerWidth(),
            toggleMiddle = togglePos.left + toggleWidth/2;
        $drawerCaret.css('left', toggleMiddle + 'px');
      }
    }
  };

  openDrawerSkeletonImmediate = function(){
    withOpenLock('drawer', function(){
      intendedDrawerOpen = true;
      $drawerContainer.addClass('is-visible is-opening');
      if (!cartInit || !$cartContainer.children().length) {
        $cartContainer.html(buildCartSkeleton(3));
        $drawerContainer.css('height', '160px'); // allow a couple rows + footer
      }
      requestAnimationFrame(function(){ $drawerContainer.removeClass('is-opening'); });
    });
  };

  showDrawer = function (toggle) {
    withOpenLock('drawer', function(){
      intendedDrawerOpen = true;

      if (!$drawerContainer.hasClass('is-visible')) {
        $drawerContainer.addClass('is-visible is-opening');
      }

      if (settings.method === 'flip') {
        Shopify.getCart(flipCartUpdateCallback);
      } else if (!cartInit && toggle) {
        $cartContainer.html(buildCartSkeleton(3));
        $drawerContainer.css('height', '160px');
        Shopify.getCart(cartUpdateCallback);
      } else if (cartInit && toggle) {
        sizeDrawer();
      }

      requestAnimationFrame(function () { $drawerContainer.removeClass('is-opening'); });

      scrollTop();
      toggleCallback({ is_visible: true });
    });
  };

  hideDrawer = function () {
    intendedDrawerOpen = false;
    if ($drawerContainer) $drawerContainer.removeAttr('style').removeClass('is-visible');
    scrollTop();
    toggleCallback({ is_visible: false });
  };

  sizeDrawer = function (empty) {
    if (empty) {
      $drawerContainer.css('height', '0px');
    } else {
      $drawerHeight = $cartContainer.outerHeight();
      $('.cart-row img').css('width', 'auto');
      $drawerContainer.css('height', $drawerHeight + 'px');
    }
  };

  loadCartImages = function () {
    if ($drawerContainer) { $drawerContainer.css('will-change', 'height'); }
    if (settings.method === 'modal' && intendedModalOpen) sizeModal();
    if (settings.method !== 'modal' && intendedDrawerOpen) sizeDrawer();

    var cartImages = $('img', $cartContainer), count = cartImages.length, index = 0;
    if (!count) return;

    cartImages.attr({ loading: 'lazy', decoding: 'async' });

    cartImages.off('load.ajaxify').on('load.ajaxify', function () {
      index++;
      if (index === count) {
        if (settings.method === 'modal' && intendedModalOpen) sizeModal();
        if (settings.method !== 'modal' && intendedDrawerOpen) sizeDrawer();
      }
    }).each(function () { if (this.complete) $(this).trigger('load'); });
  };

  /* ---------- Add-to-cart override ---------- */
  function fastAddFromForm(form, callback, errorCallback){
    var $f = $(form);
    var hasProperties = $f.find('[name^="properties["], input[type="file"]').length > 0;
    var id = $f.find('[name="id"]').val();
    var qtyField = $f.find('[name="quantity"]').val();
    var qty = parseInt(qtyField || 1, 10);

    if (hasProperties || !id) {
      Shopify.addItemFromForm(form, callback, errorCallback);
      return;
    }
    Shopify.addItem(id, qty || 1, function(line_item){
      if (typeof callback === 'function') callback(line_item, form);
      else Shopify.onItemAdded && Shopify.onItemAdded(line_item, form);
    });
  }

  formOverride = function () {
  $formContainer.off('submit.ajaxify').on('submit.ajaxify', function(e) {
    e.preventDefault();
    // Block any other submit handlers that might also add
    e.stopPropagation();
    e.stopImmediatePropagation();

    var $form = $(this);
    // Re-entrancy guard to prevent double /cart/add.js
    if ($form.data('adding')) return;
    $form.data('adding', true);

    // Force quantity=1 (belt-and-braces)
    var $qty = $form.find('[name="quantity"]');
    if (!$qty.length) { $qty = $('<input>', { type: 'hidden', name: 'quantity' }).appendTo($form); }
    $qty.val(1);

    $addToCart.removeClass('is-added').addClass('is-adding');
    $('.qty-error').remove();

    if (settings.method === 'drawer')      openDrawerSkeletonImmediate();
    else if (settings.method === 'modal')  openModalSkeletonImmediate();

    fastAddFromForm(e.target,
      function(line_item){
        // success
        $form.removeData('adding');
        itemAddedCallback(line_item);
      },
      function(){
        // error
        $form.removeData('adding');
        itemErrorCallback();
      }
    );

    if (settings.method === 'flip') {
      $flipContainer.addClass('flip--is-loading');
    }
  });
};


  itemAddedCallback = function () {
    $addToCart.removeClass('is-adding').addClass('is-added');
    if (settings.method === 'flip') {
      setTimeout(function () { $flipContainer.removeClass('flip--is-loading').addClass('is-flipped'); }, 250);
    }
    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function () {
    if (settings.method === 'flip') $flipContainer.removeClass('flip--is-loading');
  };

  /* ---------- Cart data pipeline ---------- */
  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);

    switch (settings.method) {
      case 'flip':
        $('.flip-cart span').html(cart.item_count);
        buildCart(cart);
        break;

      case 'modal':
        buildCart(cart);
        if (intendedModalOpen) sizeModal('resize');
        break;

      case 'drawer':
        buildCart(cart);
        if (intendedDrawerOpen) {
          if (!$drawerContainer.hasClass('is-visible')) { showDrawer(); }
          else { scrollTop(); }
        } else {
          sizeDrawer(true);
        }
        break;
    }
  };

  setToggleButtons = function () {
    $toggleCartButton  = $(settings.toggleCartButton);
    if ($toggleCartButton && $toggleCartButton.length) {
      // Remove any prior click handlers (from other snippets) before binding ours
      $toggleCartButton.off('click').on('click.ajaxify', function(e){
        // Suppression: ignore open attempts right after a close
        if (Date.now() < modalSuppressUntil) { e.preventDefault(); e.stopImmediatePropagation(); return false; }

        e.preventDefault();
        switch (settings.method) {
          case 'modal':
            if ($modalContainer.hasClass('is-visible')) { hideModal(); } else { showModal(true); }
            break;
          case 'drawer':
          case 'flip':
            if ($drawerContainer.hasClass('is-visible')) { hideDrawer(); } else { showDrawer(true); }
            break;
        }
      });
    }
  };

  flipCartUpdateCallback = function (cart) {
    buildCart(cart);
    if (intendedModalOpen && $modalContainer && !$modalContainer.hasClass('is-visible')) {
      $modalContainer.addClass('is-visible');
      $body.addClass('ajaxify-modal--visible');
    }
  };

  /* ---------- Rendering ---------- */
  buildCart = function (cart) {
    if (!settings.useCartTemplate || cart.item_count === 0) {
      $cartContainer.empty();
    }

    if (cart.item_count === 0) {
      $cartContainer.append(`
        <div class="ajaxifyCart--empty">
          <div class="empty-icon" aria-hidden="true">
            <i class="fa-solid fa-cart-shopping" style="color: #ccc; line-height: 100px; font-size: 60px;"></i>
          </div>
          <h2>Your basket is empty!</h2>
          <p>Looks like you haven’t added anything yet.</p>
          <a href="/collections/crash-parts" class="btn">Start shopping</a>
        </div>
      `);

      switch (settings.method) {
        case 'modal':
          sizeModal('resize');
          break;
        case 'flip':
        case 'drawer':
          sizeDrawer();
          if (!$drawerContainer.hasClass('is-visible') && cartInit) {
            sizeDrawer(true);
          }
          break;
      }
      return;
    }

    if (settings.useCartTemplate) { cartTemplate(cart); return; }

    if (!TPL.cart && window.Handlebars) {
      var src = $("#cartTemplate").html() || '';
      if (src) TPL.cart = Handlebars.compile(src);
    }

    var items = [], data = {};

    // Use a safe money format fallback
var moneyFormat = (settings && settings.moneyFormat) ||
                  (window.Shopify && Shopify.money_format) ||
                  "{{ shop.money_format | escape }}";

$.each(cart.items, function(index, cartItem) {
  var itemAdd   = cartItem.quantity + 1,
      itemMinus = cartItem.quantity - 1,
      itemQty   = cartItem.quantity + ' x';

  var img = cartItem.image || '';
  if (img) img = img.replace(/(\.[^.]*)$/, "_small$1").replace(/^http:/, '');

  var prodName      = (cartItem.title || '').replace(/(\-[^-]*)$/, "");
  var prodVariation = (cartItem.title || '').replace(/^[^\-]*/, "").replace(/-/, "");

  items.push({
    id: cartItem.variant_id,
    line: index + 1,
    url: cartItem.url,
    img: img,
    name: prodName,
    variation: prodVariation,
    itemAdd: itemAdd,
    itemMinus: itemMinus,
    itemQty: itemQty,

    // Show stable catalog unit price to avoid 1p wobble
    unitPrice: Shopify.formatMoney(cartItem.price, moneyFormat),

    // Extras (use in template if you want):
    finalPrice: Shopify.formatMoney(cartItem.final_price, moneyFormat),          // discounted unit price
    lineTotal: Shopify.formatMoney(cartItem.final_line_price, moneyFormat),      // discounted line total
    lineDiscount: cartItem.total_discount
      ? Shopify.formatMoney(cartItem.total_discount, moneyFormat)
      : null
  });
});


    data = {
  items: items,
  totalPrice: Shopify.formatMoney(cart.total_price, moneyFormat),             // after discounts
  subtotalPrice: Shopify.formatMoney(cart.items_subtotal_price, moneyFormat), // before discounts
  discountTotal: cart.total_discount ? Shopify.formatMoney(cart.total_discount, moneyFormat) : null,
  btnClass: $btnClass
};


    if (TPL.cart) {
      $cartContainer.append(TPL.cart(data));
    } else {
      $cartContainer.append('<div class="ajaxifyCart--fallback"></div>');
    }

    $cartContainer.find('img').attr({ loading: 'lazy', decoding: 'async' });

    adjustCart();

    switch (settings.method) {
      case 'modal':  loadCartImages(); break;
      case 'flip':
      case 'drawer': if (cart.item_count > 0) loadCartImages(); else sizeDrawer(true); break;
    }

    cartInit = true;
  };

  cartTemplate = function (cart) {
    $cartContainer.load('/cart form[action="/cart"]', function() {
      $cartContainer.find('img').attr({ loading: 'lazy', decoding: 'async' });

      adjustCart();
      switch (settings.method) {
        case 'modal': loadCartImages(); break;
        case 'flip':
        case 'drawer':
          if (cart.item_count > 0) loadCartImages();
          else sizeDrawer(true);
          break;
      }
      cartInit = true;
    });
  };

  /* ---------- Interactions inside cart ---------- */
  adjustCart = function () {
    if (settings.useCartTemplate) createQtySelectors();

    $body.off('submit.ajaxifyCart').on('submit.ajaxifyCart', 'form.cart-form', function(evt){
      if (isUpdating) evt.preventDefault();
    });

    var qtyAdjust = $('.ajaxifyCart--qty span');
    qtyAdjust.off('click.ajaxify').on('click.ajaxify', function(){
      var el = $(this),
          line = el.data('line'),
          qtySelector = el.siblings('.ajaxifyCart--num'),
          qty = parseInt(qtySelector.val(), 10);
      qty = validateQty(qty);
      qty = el.hasClass('ajaxifyCart--add') ? (qty + 1) : Math.max(0, qty - 1);
      if (line) updateQuantity(line, qty);
      else qtySelector.val(qty);
    });

    var qtyInput = $('.ajaxifyCart--num');
    qtyInput.off('change.ajaxify').on('change.ajaxify', function(){
      var el = $(this), line = el.data('line'), qty  = el.val();
      if (!((parseFloat(qty) == parseInt(qty,10)) && !isNaN(qty))) { el.val(1); return; }
      if (line) updateQuantity(line, qty);
    });

    qtyInput.off('focus.ajaxify').on('focus.ajaxify', function(){
      var el = $(this); setTimeout(function(){ el.select(); }, 50);
    });

    $('.ajaxifyCart--remove').off('click.ajaxify').on('click.ajaxify', function(e){
      var el = $(this), line = el.data('line') || null, qty = 0;
      if (!line) return;
      e.preventDefault(); updateQuantity(line, qty);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      var row = (!settings.useCartTemplate)
        ? $('.ajaxifyCart--row[data-line="' + line + '"]').addClass('ajaxifyCart--is-loading')
        : $('.cart-row[data-line="' + line + '"]').addClass('ajaxifyCart--is-loading');
      if (qty === 0) row.addClass('is-removed');
      setTimeout(function(){ Shopify.changeItem(line, qty, adjustCartCallback); }, 150);
    }

    var noteArea = $('textarea[name="note"]');
    noteArea.off('change.ajaxify').on('change.ajaxify', function(){
      Shopify.updateCartNote($(this).val(), function(){});
    });

    if (typeof window.GoogleWalletButton === "function") window.GoogleWalletButton();
    if (typeof window.AmazonPaymentsPayButton === "function") window.AmazonPaymentsPayButton();
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;
    updateCountPrice(cart);

    if (cart.item_count === 0) {
      if (settings.method === 'drawer' || settings.method === 'flip') hideDrawer();
    }

    setTimeout(function(){ Shopify.getCart(buildCart); }, 120);
  };

  createQtySelectors = function(){
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function(){
        var el = $(this),
            currentQty = parseInt(el.val(), 10),
            source = $("#ajaxifyQty").html() || '',
            template = window.Handlebars ? Handlebars.compile(source) : function(){ return '<div class="ajaxifyCart--qty"><span class="ajaxifyCart--minus">-</span><input class="ajaxifyCart--num" data-line="'+(el.attr('data-line')||'')+'" value="'+currentQty+'"><span class="ajaxifyCart--add">+</span></div>'; },
            data = { line: el.attr('data-line'), itemQty: currentQty + ' x', itemAdd: currentQty + 1, itemMinus: currentQty - 1 };
        el.after(template(data)).remove();
      });
    }

    if ($('a[href^="/cart/change"]', $cartContainer).length) {
      $('a[href^="/cart/change"]', $cartContainer).each(function(){ $(this).addClass('ajaxifyCart--remove'); });
    }
  };

  qtySelectors = function(){
    var numInputs = $('input[type="number"]');
    var qtyMin = 0;

    if (numInputs.length) {
      numInputs.each(function(){
        var el = $(this),
            currentQty = parseInt(el.val(), 10),
            inputName = el.attr('name'),
            inputId = el.attr('id'),
            source = $("#jsQty").html() || '',
            template = window.Handlebars ? Handlebars.compile(source) : function(){
              return '<div class="js--qty"><button type="button" class="js--qty-adjuster js--minus" data-id="'+(el.data('id')||'')+'">-</button><input class="js--num" id="'+(inputId||'')+'" name="'+(inputName||'')+'" value="'+currentQty+'" /><button type="button" class="js--qty-adjuster js--add" data-id="'+(el.data('id')||'')+'">+</button></div>';
            },
            data = { id: el.data('id'), itemQty: currentQty, itemAdd: currentQty + 1, itemMinus: currentQty - 1, inputName: inputName, inputId: inputId };

        el.after(template(data)).remove();
      });

      $('.js--qty-adjuster').off('click.ajaxify').on('click.ajaxify', function(){
        var el = $(this),
            qtySelector = el.siblings('.js--num'),
            qty = parseInt(qtySelector.val(), 10);
        qty = validateQty(qty);
        qtyMin = $body.hasClass('template-product') ? 1 : qtyMin;
        qty = el.hasClass('js--add') ? (qty + 1) : Math.max(qtyMin, qty - 1);
        qtySelector.val(qty);
      });
    }
  };

  scrollTop = function () {
    if ($body.scrollTop() > 0 || $html.scrollTop() > 0) {
      $('html, body').stop(true).animate({ scrollTop: 0 }, 200, 'swing');
    }
  };

  toggleCallback = function (data) {
    if (typeof settings.onToggleCallback === 'function') {
      settings.onToggleCallback.call(this, data);
    }
  };

  validateQty = function (qty) {
    if ((parseFloat(qty) == parseInt(qty, 10)) && !isNaN(qty)) return parseInt(qty, 10);
    return 1;
  };

  module = { init: init };
  return module;

}(ajaxifyShopify || {}, jQuery));
